<template>
    <div class="menu">
        <div class="clearfix">
            <b-link class="navbar-brand" to="/">
                <img
                    src="../assets/images/logo/logo_ic.png"
                    height="105"
                    alt="immocoach logo"
                    align="left"
                />
            </b-link>

            <div class="nav-toggler-wrapper">
                <nav-toggler
                    :menu-expanded="menuExpanded"
                    @click="menuExpansionStateChanged"
                />
            </div>
        </div>

        <b-collapse id="nav_collapse" v-model="menuExpanded">
            <router-link
                class="nounderline text-right nav-item"
                @click="menuExpansionStateChanged"
                v-b-toggle.nav_collapse
                v-bind:to="'/'"
            >
                <h4 class="item">Home</h4>
            </router-link>
            <router-link
                class="nounderline text-right nav-item"
                @click="menuExpansionStateChanged"
                v-b-toggle.nav_collapse
                v-bind:to="'/about'"
            >
                <h4 class="item">Über uns</h4>
            </router-link>
            <router-link
                class="nounderline text-right nav-item"
                @click="menuExpansionStateChanged"
                v-b-toggle.nav_collapse
                v-bind:to="'/references'"
            >
                <h4 class="item">Referenzen</h4>
            </router-link>
        </b-collapse>
    </div>
</template>

<script>
import NavToggler from './menu/NavToggleComponent.vue'

export default {
    name: 'immo_menu',
    components: {
        NavToggler
    },
    data() {
        return {
            menuExpanded: false
        }
    },
    methods: {
        toggleClass: function() {
            this.menuExpanded = !this.menuExpanded
        },
        menuExpansionStateChanged: function() {
            this.menuExpanded = !this.menuExpanded
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.nav-toggler-wrapper {
    float: right;
}

.navbar-brand {
    float: left;
}

.navbar {
    background-color: white;
}

.nav-item {
    font-family: 'miso-light', Arial, sans-serif;
}

.item {
    color: black;
    text-decoration: none;
    padding: 10px 0;
}

.padder {
    padding-left: 100px;
    padding-right: 100px;
}

.nounderline {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuComponent.vue